import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SETTINGS_ACTION_TYPE = createNamedActions('settings', {
  SET_SETTINGS: 'SET_SETTINGS',
  SET_DEFAULT_SETTINGS: 'SET_DEFAULT_SETTINGS',
  SET_INITIAL_SETTINGS: 'SET_INITIAL_SETTINGS',
  RESET_DEFAULT_SETTINGS: 'RESET_DEFAULT_SETTINGS',
  SET_IS_SIDEBAR_OPEN: 'SET_IS_SIDEBAR_OPEN',
});

export const setSettingsAction = payload => ({
  type: SETTINGS_ACTION_TYPE.SET_SETTINGS,
  payload,
});

export const setDefaultSettingsAction = payload => ({
  type: SETTINGS_ACTION_TYPE.SET_DEFAULT_SETTINGS,
  payload,
});

export const resetSettingsAction = payload => ({
  type: SETTINGS_ACTION_TYPE.RESET_DEFAULT_SETTINGS,
  payload,
});

export const setIsSidebarOpenAction = isOpen => ({
  type: SETTINGS_ACTION_TYPE.SET_IS_SIDEBAR_OPEN,
  payload: isOpen,
});
